import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../context/AuthContext';

/**
 * PrivateRoute - Simple authentication guard following OrcaWebsite pattern
 * Redirects to login if user is not authenticated
 * Much simpler than the old ProtectedRoute component
 */
export const PrivateRoute = ({ children }: any) => {
    const { loggedInUser } = useAuthStore();

    if (!loggedInUser) {
        return <Navigate to="/login" />;
    }

    return children;
};
